module.exports = "<footer class=\"footer\"></footer>\n"